import { VideoPlayerCorvidState } from '../VideoPlayer.types';

const mapActionsToProps = ({ updateProps }: { updateProps: any }) => ({
  updateState: (props: VideoPlayerCorvidState) => {
    updateProps({ ...props });
  },
});

export default mapActionsToProps;
